// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-date-picker label{display:none}.occurrences-text{pointer-events:none}", ""]);
// Exports
module.exports = exports;
